var Table = new Class({
	Implements: Options,
	options: {
	},
	initialize: function(_element, options) {
		this._element = document.id(_element);
		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},
	build: function() {}
});

Table.RecentClosings = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table,
	build: function() {
		this.parent();
		// console.log('Table.RecentClosings build');
		if(Page.Bir){
			Page.Bir.make_table(this._element);
		}
	}
});

Table.Available = new Class({ //used as data-class in some widgets (i.e. widgets on building overview page)
	Extends: Table.RecentClosings,
	build: function() {
		this.parent();
		// console.log('Table.Available build');
	}
});

Table.Available.ForSale = new Class({
	Extends: Table.Available,
	build: function() {
		this.parent();
		
		// console.log('Table.Available.ForSale build');
	}
});